import { FilterConfig } from './useAccountFiltersValues.types'

export const getTransactionTypeFromInitialConfig = (
  initialConfig: Partial<FilterConfig> | undefined
) => initialConfig?.transactionType?.items?.map((item) => item.value)
